module.exports = __webpack_public_path__ + "static/img/bg.9cd46850.png";